/* eslint-disable no-param-reassign */
export default class ArrayHelper {
  static inArray(needle, stack) {
    if (!Array.isArray(stack)) {
      throw new Error('Arg `stack` must be array')
    }

    if (!Array.isArray(needle)) {
      return stack.indexOf(needle) !== -1
    }

    for (const key in needle) {
      if (stack.indexOf(needle[key]) !== -1) {
        return true
      }
    }

    return false
  }

  static map(a, k) {
    const o = {}

    // eslint-disable-next-line guard-for-in
    for (const i in a) {
      const row = a[i]
      o[row[k]] = row
    }

    return o
  }

  static hasInArray(list, value, key) {
    if (key) {
      for (const index in list) {
        if (list[index][key] === value) return true
      }
    } else {
      for (const index in list) {
        if (list[index] === value) return true
      }
    }

    return false
  }

  static getValues(values, list) {
    let result = []

    if (!values.size) {
      result = list.map(item => item.id).toArray()
    } else if (list.size) {
      if (Number(values.get(0)) === -1) {
        result = []
      } else {
        result = values.toArray()
      }
    }

    return result
  }

  static getArrData(currentValues, data = []) {
    const [firstItem] = currentValues || []

    if (Array.isArray(currentValues)) {
      if (Number(firstItem) === -1) {
        data = currentValues
      } else if (currentValues.length === 1 && !firstItem) {
        return
      } else if (currentValues.length >= 1) {
        data = currentValues.filter(item => item).map(item => item.index)
      }
    }

    return data
  }
}
